import { QueryClient } from '@tanstack/vue-query'

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
    },
  },
})

export function resetQueryClient() {
  queryClient.clear()
  queryClient.resetQueries()
  queryClient.invalidateQueries()
}
